import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M17.483 6a1.084 1.084 0 1 0-2.167 0zm-1.85 14.226c.423.423 1.11.423 1.533 0l6.895-6.896a1.084 1.084 0 0 0-1.532-1.533l-6.13 6.13-6.13-6.13a1.084 1.084 0 0 0-1.532 1.533zM15.316 6v13.46h2.167V6z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#fff",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.167",
  d: "M2 22.795V27h28.8v-4.205"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }